export const TermsAndConditions = [
    {
      id: '1',
      questionKey: 'TermsAndConditions.registration_data_management',
      pointsKeys: [
        'TermsAndConditions.registration_1_1',
        'TermsAndConditions.registration_1_2',
        'TermsAndConditions.registration_1_3',
        'TermsAndConditions.registration_1_4'
      ]
    },
    {
      id: '2',
      questionKey: 'TermsAndConditions.subscriptions_and_changes',
      pointsKeys: [
        'TermsAndConditions.subscriptions_2_1',
        'TermsAndConditions.subscriptions_2_2',
        'TermsAndConditions.subscriptions_2_3',
        'TermsAndConditions.subscriptions_2_4'
      ]
    },
    {
      id: '3',
      questionKey: 'TermsAndConditions.package_reduction_cancellation',
      pointsKeys: [
        'TermsAndConditions.package_reduction_3_1',
        'TermsAndConditions.package_reduction_3_2'
      ]
    },
    {
      id: '4',
      questionKey: 'TermsAndConditions.subscription_cancellation_policy',
      pointsKeys: [
        'TermsAndConditions.cancellation_4_1',
        'TermsAndConditions.cancellation_4_2',
        'TermsAndConditions.cancellation_4_3'
      ]
    },
    {
      id: '5',
      questionKey: 'TermsAndConditions.payment_policies',
      pointsKeys: [
        'TermsAndConditions.payment_5_1',
        'TermsAndConditions.payment_5_2',
        'TermsAndConditions.payment_5_3',
        'TermsAndConditions.payment_5_4'
      ]
    },
    {
      id: '6',
      questionKey: 'TermsAndConditions.discount_policies',
      pointsKeys: [
        'TermsAndConditions.discount_6_1',
        'TermsAndConditions.discount_6_2'
      ]
    },
    {
      id: '7',
      questionKey: 'TermsAndConditions.privacy_security_policies',
      pointsKeys: [
        'TermsAndConditions.privacy_7_1',
        'TermsAndConditions.privacy_7_2'
      ]
    },
    {
      id: '8',
      questionKey: 'TermsAndConditions.technical_support',
      pointsKeys: [
        'TermsAndConditions.support_8_1',
        'TermsAndConditions.support_8_2'
      ]
    },
    {
      id: '9',
      questionKey: 'TermsAndConditions.update_change_policies',
      pointsKeys: [
        'TermsAndConditions.update_9_1',
        'TermsAndConditions.update_9_2'
      ]
    },
    {
      id: '10',
      questionKey: 'TermsAndConditions.usage_compliance_laws',
      pointsKeys: [
        'TermsAndConditions.usage_10_1',
        'TermsAndConditions.usage_10_2'
      ]
    },
    {
      id: '11',
      questionKey: 'TermsAndConditions.terms_modifications',
      pointsKeys: [
        'TermsAndConditions.modifications_11_1',
        'TermsAndConditions.modifications_11_2'
      ]
    },
    {
      id: '12',
      questionKey: 'TermsAndConditions.contract_termination',
      pointsKeys: [
        'TermsAndConditions.termination_12_1',
        'TermsAndConditions.termination_12_2'
      ]
    }
  ]